import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckInComponentV2 } from '../../blocks-v2/check-in-v2/check-in-v2.component';
import { ConciergeComponentV2 } from '../../blocks-v2/concierge-v2/concierge-v2.component';
import { CounterComponentV2 } from '../../blocks-v2/counter-v2/counter-v2.component';
import { DisclaimerComponentV2 } from '../../blocks-v2/disclaimer-v2/disclaimer-v2.component';
import { EventComponentV2 } from '../../blocks-v2/event-v2/event-v2.component';
import { GiftVoucherComponentV2 } from '../../blocks-v2/gift-voucher-v2/gift-voucher-v2.component';
import { HeadingComponentV2 } from '../../blocks-v2/heading-v2/heading-v2.component';
import { InspirationComponentV2 } from '../../blocks-v2/inspiration-v2/inspiration-v2.component';
import { MainBannerComponentV2 } from '../../blocks-v2/main-banner-v2/main-banner-v2.component';
import { MomentsComponentV2 } from '../../blocks-v2/moments-v2/moments-v2.component';
import { Only2PhotosComponentV2 } from '../../blocks-v2/only-2-photos-v2/only-2-photos-v2.component';
import { OnlyCtaComponentV2 } from '../../blocks-v2/only-cta-v2/only-cta-v2.component';
import { OnlyIntroComponentV2 } from '../../blocks-v2/only-intro-v2/only-intro-v2.component';
import { ParagraphCtaComponentV2 } from '../../blocks-v2/paragraph-cta-v2/paragraph-cta-v2.component';
import { PropertyDescriptionComponentV2 } from '../../blocks-v2/property-description-v2/property-description-v2.component';
import { PropertyUsp1xPhotoComponentV2 } from '../../blocks-v2/property-usp-1x-photo-v2/property-usp-1x-photo-v2.component';
import { PropertyUsp2xPhotoComponentV2 } from '../../blocks-v2/property-usp-2x-photo-v2/property-usp-2x-photo-v2.component';
import { ReservationComponentV2 } from '../../blocks-v2/reservation-v2/reservation-v2.component';
import { ReviewsComponentV2 } from '../../blocks-v2/reviews-v2/reviews-v2.component';
import { ValamarAppComponentV2 } from '../../blocks-v2/valamar-app-v2/valamar-app-v2.component';
import { VoucherComponentV2 } from '../../blocks-v2/voucher-v2/voucher-v2.component';
import { X2ExperiencesComponentV2 } from '../../blocks-v2/x2-experiences-v2/x2-experiences-v2.component';
import { X2PropRecComponentV2 } from '../../blocks-v2/x2-prop-rec-v2/x2-prop-rec-v2.component';
import { X2PropRecOnpComponentV2 } from '../../blocks-v2/x2-prop-rec-onp-v2/x2-prop-rec-onp-v2.component';
import { X3ExperiencesComponentV2 } from '../../blocks-v2/x3-experiences-v2/x3-experiences-v2.component';
import { ZigZagHeadingAndAltCtaComponentV2 } from '../../blocks-v2/zigzag-heading-and-alt-cta-v2/zigzag-heading-and-alt-cta-v2.component';
import { ZigZagHeadingAndCtaComponentV2 } from '../../blocks-v2/zigzag-heading-and-cta-v2/zigzag-heading-and-cta-v2.component';
import { ZigZagNoHeadingNoButtonComponentV2 } from '../../blocks-v2/zigzag-no-heading-no-button-v2/zigzag-no-heading-no-button-v2.component';

/**
 * Renders exactly one email/reviews block, in either edit mode (full block:
 * form + preview + its own comments-side, `isPreview=false`) or pure-preview
 * mode (`isPreview=true`, same mechanism the existing app-preview route uses).
 * Thin switch + pass-through wrapper around the existing, unmodified block
 * components — introduced so template-editor-v2 doesn't need to duplicate the
 * ~30-case block switch in both preview-v2 and edit-block-comments-v2.
 */
@Component({
  selector: 'app-block-renderer-v2',
  imports: [
    CommonModule,
    CheckInComponentV2,
    ConciergeComponentV2,
    CounterComponentV2,
    DisclaimerComponentV2,
    EventComponentV2,
    GiftVoucherComponentV2,
    HeadingComponentV2,
    InspirationComponentV2,
    MainBannerComponentV2,
    MomentsComponentV2,
    Only2PhotosComponentV2,
    OnlyCtaComponentV2,
    OnlyIntroComponentV2,
    ParagraphCtaComponentV2,
    PropertyDescriptionComponentV2,
    PropertyUsp1xPhotoComponentV2,
    PropertyUsp2xPhotoComponentV2,
    ReservationComponentV2,
    ReviewsComponentV2,
    ValamarAppComponentV2,
    VoucherComponentV2,
    X2ExperiencesComponentV2,
    X2PropRecComponentV2,
    X2PropRecOnpComponentV2,
    X3ExperiencesComponentV2,
    ZigZagHeadingAndAltCtaComponentV2,
    ZigZagHeadingAndCtaComponentV2,
    ZigZagNoHeadingNoButtonComponentV2,
  ],
  templateUrl: './block-renderer-v2.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BlockRendererV2Component {
  @Input() block: any;
  @Input() isPreview = false;
  /** Only consumed by app-main-banner-v2's popout WYSIWYG button today; other
   *  (real, unmodified) block components ignore it, relying on the shared
   *  .disable-editor class instead. */
  @Input() disabled = false;
  /** Only consumed by app-main-banner-v2 today, to show the desktop or
   *  mobile image in the center summary matching the canvas's own toggle. */
  @Input() deviceMode: 'desktop' | 'mobile' = 'desktop';

  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<any>();

  onBlockData(event: any): void {
    this.blockData.emit(event);
  }

  onRemoveBlock(event: any): void {
    this.removeBlockEvent.emit(event);
  }
}
